import { Injectable, Inject, Optional } from '@angular/core';
import { WizardType } from 'src/app/core/enums/wizard-type.enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WizardTypeService {
  private _wizardType: WizardType;
  private readonly host: string;

  constructor(@Optional() @Inject('HOST_OVERRIDE') hostOverride?: string) {
    this.host = hostOverride || window.location.host;
    this._wizardType = this.determineWizardType();
  }

  private determineWizardType(): WizardType {
    if (
      this.host === environment.wizardHosts.LQSBOX ||
      this.host === environment.betaWizardHosts.LQSBOX
    ) {
      return WizardType.LQSBOX;
    }
    if (
      this.host === environment.wizardHosts.LQS ||
      this.host === environment.betaWizardHosts.LQS
    ) {
      return WizardType.LQS;
    }
    if (
      this.host === environment.wizardHosts.EMH ||
      this.host === environment.betaWizardHosts.EMH
    ) {
      return WizardType.EMH;
    }

    console.warn(`Unknown hostname (${this.host}), defaulting to LQS.`);
    return WizardType.LQS;
  }

  get wizardType(): WizardType {
    return this._wizardType;
  }
}
